/**
 * Chặn phản hồi về lệch thứ tự: nhiều lời gọi cùng trả về trạng thái (tải lại do hub, do tải lại
 * dự phòng, do nối lại mạng, và phản hồi của các lệnh ghi) có thể về không theo thứ tự gửi. Nếu
 * áp một phản hồi cũ đè lên trạng thái mới hơn thì màn hình quay về trạng thái đã qua (vd overlay
 * dừng bài vừa bắt đầu vì nhận lại trạng thái cũ).
 *
 * Mỗi lời gọi lấy một số thứ tự (`issue`) lúc gửi, rồi hỏi gate trước khi áp phản hồi:
 * - Lệnh đọc (`acceptRead`): chỉ áp nếu từ lúc gửi tới giờ chưa gửi lời gọi nào mới hơn.
 * - Lệnh ghi (`acceptWrite`, phản hồi là trạng thái ngay sau khi ghi): áp nếu mới hơn mọi phản hồi
 *   đã áp; áp xong thì mọi lời gọi gửi trước thời điểm này đều coi là cũ, vì máy chủ có thể đã
 *   xử lý chúng trước lệnh ghi. Thay đổi sau đó máy chủ sẽ đẩy qua hub, lần tải sau sẽ lấy lại.
 */
export interface ResponseGate {
  issue: () => number;
  acceptRead: (token: number) => boolean;
  acceptWrite: (token: number) => boolean;
}

export const createResponseGate = (): ResponseGate => {
  let issued = 0;
  let applied = 0;
  return {
    issue: () => {
      issued += 1;
      return issued;
    },
    acceptRead: (token) => {
      if (token !== issued || token <= applied) return false;
      applied = token;
      return true;
    },
    acceptWrite: (token) => {
      if (token <= applied) return false;
      applied = issued;
      return true;
    },
  };
};
